export default {
    dealers_main_id: 'Id',
    dealers_main_name: 'Nombre',
    dealers_main_email: 'Correo',
    dealers_main_username: 'Nombre de usuario',
    dealers_main_companies: 'Compañias',
    dealers_main_dealers: 'Distribuidores',
    dealers_main_master_company_name: 'Compañía Maestra',
    dealers_main_apply: 'Aplicar',
    dealers_main_tags: 'Etiquetas',
    dealers_main_active_dealers_only: 'Sólo cuentas activas',
    dealers_main_yes: 'Si',
    dealers_main_no: 'No',
    dealers_main_authenticate_cloud: 'Iniciar sesión como cliente',
    dealers_main_re_sync_backend_information: 'Re-sincronización de la información del backend',
    dealers_main_devices: 'Dispositivos',
    dealers_main_package: 'Paquete',
    dealers_main_crm: 'Id. de Salesforce',
    dealers_main_add_dealer: 'Agregar distribuidor',
    dealers_main_edit: 'Editar',
    dealers_main_remove_filters: 'Eliminar los filtros',
    dealers_main_account_details: 'Detalles de la cuenta',
    dealers_main_import_from_p4: 'Importar desde P4',
    dealers_main_reprocess_odo_hours: 'Reprocesar Odo/Hrs',
    dealers_main_new_status: 'Nuevo Estado',
    dealers_main_at: 'el',
    dealers_main_next_scheduled_action: 'Próxima acción programada',
    dealers_main_on: 'en',
    dealers_main_brand: 'Marca',
};